import * as React from 'react';
const EmptyList = [];
export const PathRegisterContext = React.createContext(null);
export function useMeasure() {
    return React.useContext(PathRegisterContext);
}
// ========================= Path Tracker ==========================
export const PathTrackerContext = React.createContext(EmptyList);
export function useFullPath(eventKey) {
    const parentKeyPath = React.useContext(PathTrackerContext);
    return React.useMemo(() => (eventKey !== undefined ? [...parentKeyPath, eventKey] : parentKeyPath), [parentKeyPath, eventKey]);
}
export const PathUserContext = React.createContext(null);
